<template>
  <div>
    <v-card-title
      class="ma-0 pa-0"
      :style="vTitleStyle"
    >
      <!-- <v-card-title :class="secondary ? $ftStyle.secondaryPageBar : $ftStyle.pageBar" class="pa-0"> -->
      <v-toolbar
        dark
        :color="secondary ? $ftStyle.secondaryPageBar : $ftStyle.pageBar"
        :fixed="fixed"
        :flat="!fixed"
        :dense="!fixed"
        :class="{'ft-page-bar': true, 'ft-small-shadow': !fixed}"
        @heightChange="updateToolbarContainer"
      >
        <v-btn
          v-if="onClose"
          dark
          icon
          @click="onClose"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-tooltip
          v-else-if="onBack"
          class="ma-0 pa-0"
          top
        >
          <template v-slot:activator="{ on }">
            <v-btn
              dark
              icon
              @click="onBackAction"
            >
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
          </template>
          <span>{{ backTip || 'Go Back' }}</span>
        </v-tooltip>
        <span>
          <span
            class="d-sm-none subtitle-2"
            style="line-height: 1em;"
          >{{ title }}</span>
          <span class="d-none d-sm-flex title">{{ title }}</span>
        </span>
        <v-spacer />
        <slot name="bar-right" />
        <page-bar-button
          v-for="(button, i) of beforeTimerButtons"
          :key="i"
          :button="button"
        />
        <lock-timer
          v-if="lockTimer && lockTimer.endTime"
          class="mx-1"
          dark
          v-bind="lockTimer"
        />
        <slot />
        <page-bar-button
          v-for="(button, i) of afterTimerButtons"
          :key="i"
          :button="button"
        />
        <page-context-menu
          :items="contextMenu"
          offset-right
          :for-fixed="fixed"
          :menu-class="fixed ? 'ft-modal-menu-hack' : ''"
        />
        <v-progress-linear
          style="position: absolute; bottom: -2px; left: 0;"
          :indeterminate="loading"
          height="2"
          class="ma-0 pa-0"
          :color="loading ? 'success' : 'none'"
        />
      </v-toolbar>
    </v-card-title>
    <v-card-text class="ma-0 pa-0">
      <slot name="after-progress" />
    </v-card-text>
  </div>
</template>

<script>
import fixedBarModal from '../mixins/fixedBarModal'
import PageBarButton from './PageBarButton'
import PageContextMenu from './PageContextMenu'
import LockTimer from './LockTimer'

export default {
  name: 'PageBar',
  components: {
    PageBarButton,
    PageContextMenu,
    LockTimer
  },
  mixins: [fixedBarModal],

  props: {
    title: String,
    onBack: [Function, Boolean],
    onClose: Function,
    backTip: [String, Boolean],
    contextMenu: Array,
    buttons: Array,
    lockTimer: [Object, Boolean],
    loading: Boolean,
    secondary: Boolean,
    fixed: Boolean,
    hidePageScrollbar: Boolean
  },
  data: function () {
    return {
      toolbarContainerSize: 64
    }
  },

  computed: {
    beforeTimerButtons () {
      return (this.buttons || []).filter(b => !b.hide && b.beforeTimer)
    },
    afterTimerButtons () {
      return (this.buttons || []).filter(b => !b.hide && !b.beforeTimer)
    },
    vTitleStyle () {
      return this.fixed ? 'min-height: ' + this.toolbarContainerSize + 'px !important' : ''
    },
    onBackAction () {
      if (typeof this.onBack === 'function') {
        return this.onBack
      }
      return () => {this.$router.go(-1)}
    }
  },

  watch: {
    fixed (val) {
      if (val) {
        this.setModalOffsetTop()
      }
    }
  },

  beforeDestroy () {
    // this.setModalOffsetTop()
  },

  methods: {
    updateToolbarContainer (val) {
      this.toolbarContainerSize = val
    }
  }
}
</script>
<style>
  .ft-page-bar .v-toolbar__content {
    padding-right: 0;
  }
  .ft-small-shadow {
    box-shadow: 0px 0px 1px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12) !important
  }
</style>
